import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async create(datos) {
    return await axiosIns.post(obtenerUrlAPIComisiones('montos-comisiones'), datos);
  },
  async findAll() {
    return await axiosIns.get(obtenerUrlAPIComisiones('montos-comisiones'));
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`montos-comisiones/${id}`));
  },
  async update(id, datos) {
    return await axiosIns.patch(obtenerUrlAPIComisiones(`montos-comisiones/${id}`), datos);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIComisiones(`montos-comisiones/${id}`));
  },
  async findByInstitucion(institucionId) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`montos-comisiones/instituciones/${institucionId}`));
  },
};
